<div [formGroup]="dateForm" class="w-full flex flex-row gap-2">
    <select class="flex-1 select select-bordered" [ngClass]="{ 'select-error': invalid }" formControlName="month">
        <option *ngFor="let month of months" [value]="month.zeroBasedIndex">
            {{ month.name }}
        </option>
    </select>

    <select class="select select-bordered" [ngClass]="{ 'select-error': invalid }" formControlName="year">
        <option *ngFor="let year of selectableYears" [value]="year">
            {{ year }}
        </option>
    </select>
</div>
